import { useState, useEffect } from "react";
import {
    Box,
    Backdrop,
    Paper,
    Stack,
    Typography,
} from "@mui/material";

import CustomButton from "../custom_components/CustomButton";
import CustomModalHeader from "../custom_components/CustomModalHeader";

import { getRecentOrders, removeRecentOrder } from "../../utils/recentOrders";

export default function RecentlySubmitOrder({ open, onClose, onInsert, }) {

    const [recentOrders, setRecentOrders] = useState([]);

    useEffect(() => {
        setRecentOrders(getRecentOrders());
    }, [open]);

    // USE RECENTLY ADDED ORDER
    const handleUseRecentOrder = (recentOrder) => {
        const newOrderItem = {
            itemName: recentOrder.itemName || "",
            category: recentOrder.category || "",
            quantity: recentOrder.quantity || 0,
            price: recentOrder.price || 0,
            sfee: recentOrder.sfee || 0,
            cargo: recentOrder.cargo || "",
        };

        onInsert(newOrderItem);
    };

    // REMOVE RECENTLY ADDED ORDER
    const handleRemoveRecentOrder = (recentOrder) => {
        if (removeRecentOrder(recentOrder)) {
            setRecentOrders((prevOrders) =>
                prevOrders.filter(
                    (order) => order.orderId !== recentOrder
                )
            );
        }
    };

    const handleClose = () => {
        onClose();
    }

    return (
        <Backdrop
            aria-hidden="false"
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backdropFilter: "blur(1px)",
            }}
        >
            <Paper
                sx={{
                    minWidth: 500,
                    maxWidth: 800,
                    p: 3,
                    width: "100%",
                    borderRadius: 2,

                    position: "relative",
                    overflow: "hidden",
                    "&::before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: "#2e3489"
                    }
                }}
            >

                <CustomModalHeader
                    title="Recently Add Order's"
                    onClose={onClose}
                />

                <Box
                    sx={{
                        overflowY: "auto",
                        "&::-webkit-scrollbar": {
                            width: 6,
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#d1d5db",
                            borderRadius: 10,
                        },
                    }}
                >

                    {recentOrders.length === 0 ? (

                        // EMPTY
                        <Box sx={{ py: 6, textAlign: "center", }} >

                            <Typography
                                sx={{
                                    fontSize: 14,
                                    fontWeight: 600,
                                    color: "#6b7280",
                                }}
                            >
                                No recent orders
                            </Typography>

                            <Typography
                                sx={{
                                    mt: 0.5,
                                    fontSize: 12,
                                    color: "#9ca3af",
                                }}
                            >
                                Submitted orders will appear here.
                            </Typography>

                        </Box>

                    ) : (

                        <Stack
                            spacing={1}
                            sx={{
                                minHeight: 220,
                                maxHeight: 400,
                                overflowY: "auto",
                                overflowX: "hidden",
                            }}
                        >

                            {recentOrders.map((order) => (

                                <Paper
                                    key={order.id}
                                    elevation={0}
                                    sx={{
                                        p: 1.5,
                                        border: "1px solid #e5e7eb",
                                        borderRadius: 1.5,
                                        cursor: "pointer",
                                        transition: "all 0.15s ease",

                                        "&:hover": {
                                            backgroundColor: "#f8fafc",
                                            borderColor: "#cbd5e1",
                                            transform: "translateY(-1px)",
                                            boxShadow: "8 8px 8px rgba(15, 23, 42, 0.04)",
                                        },
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                    >
                                        <Stack direction="column">
                                            {/* ITEM NAME */}
                                            <Typography
                                                sx={{
                                                    fontSize: 14,
                                                    fontWeight: 600,
                                                    color: "#111827",
                                                    lineHeight: 1.3,
                                                    mb: 1,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {order.itemName || "No Item"}
                                            </Typography>
                                            
                                            {/* DETAILS */}
                                            <Stack
                                                direction="row"
                                                spacing={2}
                                                alignItems="center"
                                                flexWrap="wrap"
                                                useFlexGap
                                            >
                                                {/* QUANTITY */}
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 10,
                                                            color: "#9ca3af",
                                                            lineHeight: 1.2,
                                                        }}
                                                    >
                                                        QTY
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                            color: "#374151",
                                                        }}
                                                    >
                                                        {order.quantity || 0}
                                                    </Typography>
                                                </Box>

                                                {/* CATEGORY */}
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 10,
                                                            color: "#9ca3af",
                                                            lineHeight: 1.2,
                                                        }}
                                                    >
                                                        CATEGORY
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                            color: "#374151",
                                                        }}
                                                    >
                                                        {order.category || "-"}
                                                    </Typography>
                                                </Box>

                                                {/* PRICE */}
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 10,
                                                            color: "#9ca3af",
                                                            lineHeight: 1.2,
                                                        }}
                                                    >
                                                        PRICE
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                            color: "#374151",
                                                        }}
                                                    >
                                                        ₱{Number(order.price || 0).toLocaleString()}
                                                    </Typography>
                                                </Box>

                                                {/* S.FEE */}
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 10,
                                                            color: "#9ca3af",
                                                            lineHeight: 1.2,
                                                        }}
                                                    >
                                                        S.FEE
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                            color: "#374151",
                                                        }}
                                                    >
                                                        ₱{Number(order.sfee || 0).toLocaleString()}
                                                    </Typography>
                                                </Box>

                                                {/* CARGO */}
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 10,
                                                            color: "#9ca3af",
                                                            lineHeight: 1.2,
                                                        }}
                                                    >
                                                        CARGO
                                                    </Typography>

                                                    <Typography
                                                        sx={{
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                            color: "#374151",
                                                        }}
                                                    >
                                                        {order.cargo || "-"}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </Stack>

                                        {/* ACTIONS */}
                                        <Stack direction="row" spacing={2} ml={2}> 
                                            <CustomButton
                                                label="Remove"
                                                variant="outlined"
                                                hoverColor="#d14249"
                                                onClick={() => handleRemoveRecentOrder(order.orderId)}
                                            />
                                            <CustomButton
                                                label="Use"
                                                onClick={() => handleUseRecentOrder(order)}
                                            />
                                        </Stack>
                                    </Stack>
                                </Paper>

                            ))}

                        </Stack>

                    )}

                </Box>

                <Stack direction="row" spacing={2} mt={3} justifyContent="flex-end">
                    <CustomButton
                        label="Cancel"
                        variant="outlined"
                        hoverColor="#d14249"
                        onClick={handleClose}
                    />
                </Stack>

            </Paper>

        </Backdrop>
    );
};